module.exports = __webpack_public_path__ + "static/media/YM75_3.a1371c2d.jpg";